<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app{
  font-family: 'SourceHanSansCN-Regular';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  line-height: 1;
}
body{
  margin: 0px;
  padding: 0px;
}
@font-face {
  font-family: 'SourceHanSansCN-Regular';
  src: url('https://hfy-img.xzyunchuang.com/SourceHanSansCN-Regular.woff');
}

html{
  font-size: 16px;
  box-sizing: content-box;
}

/* 替换的富文本样式 */
.content-img {
  /* width: 100% !important; */
  height: auto !important;
  max-width: 100% !important;
}
.content-video{
  /* width: 100% !important; */
  height: auto !important;
  max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue